import styled, { Breakpoint, css } from '@nfinite/react-hubstairs/styled'

export const TEMPLATE = {
  SMALL: { mobile: '1fr', md: '1fr 1fr', xxxl: '1fr 1fr 1fr 1fr', xxxxl: '1fr 1fr 1fr 1fr 1fr 1fr' },
  MEDIUM: { mobile: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr', xxxl: '1fr 1fr 1fr 1fr', xxxxl: '1fr 1fr 1fr 1fr 1fr' },
  LARGE: {
    mobile: '1fr 1fr',
    sm: '1fr 1fr 1fr',
    lg: '1fr 1fr 1fr 1fr',
    xxxl: '1fr 1fr 1fr 1fr',
    xxxxl: '1fr 1fr 1fr 1fr 1fr',
  },
  EXTRA_LARGE: {
    mobile: '1fr 1fr',
    sm: '1fr 1fr 1fr',
    md: '1fr 1fr 1fr 1fr',
    lg: '1fr 1fr 1fr 1fr 1fr',
    xl: '1fr 1fr 1fr 1fr 1fr 1fr',
    xxl: '1fr 1fr 1fr 1fr 1fr 1fr',
    xxxl: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
  },
}

function getColumns({ template }) {
  const { mobile, ...breakpoints } = template

  return Object.keys(breakpoints).map(bp => {
    return css`
      ${Breakpoint.greaterOrEqualThan(bp)} {
        grid-template-columns: ${template[bp]};
      }
    `
  })
}

export const Empty = styled('div')`
  width: 100%;
  display: none;
`

export const Container = styled('div')`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: ${({ template }) => template?.mobile ?? template};

  ${({ template }) => template?.mobile && getColumns}

  ${Empty}:only-child {
    display: initial;
    grid-column: 1/-1;
  }
`
